import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { CheckCircle2, Phone } from 'lucide-react';
export function Ammunition() {
  useDocumentMeta('Ammunition in Lake Benton, Minnesota | Kjergaard Sports', 'Large in-store ammunition selection for hunting, target shooting, trap, skeet, waterfowl, upland, turkey, big game, and personal defense at Kjergaard Sports.');
  const categories = ['Hunting ammunition', 'Target shooting ammunition', 'Trap and skeet', 'Waterfowl', 'Upland', 'Turkey', 'Big game', 'Varmint', 'Personal defense', 'Popular calibers'];
  return <div data-id="element-156">
      <PageHero title="Ammunition in Lake Benton, Minnesota" image="https://cdn.magicpatterns.com/uploads/w1nfdCex88kVGKJTVUQepJ/ammunition-wall.jpg" alt="Ammunition and reloading supplies at Kjergaard Sports" data-id="element-157" />

      <section className="py-20 bg-brand-offwhite" data-id="element-158">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159">
          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-160">
            <div className="order-2 lg:order-1" data-id="element-161">
              <img src="https://cdn.magicpatterns.com/uploads/w1nfdCex88kVGKJTVUQepJ/ammunition-wall.jpg" alt="Ammunition selection at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-162" />
            </div>

            <div className="order-1 lg:order-2" data-id="element-163">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-164">
                A Massive In-Store Selection
              </h2>
              <p className="text-lg text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-165">
                Whether you are preparing for hunting season, stocking up for a
                weekend at the range, or looking for reliable personal defense
                rounds, Kjergaard Sports maintains a large and diverse inventory
                of ammunition.
              </p>

              <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream mb-8" data-id="element-166">
                <h3 className="font-serif text-xl mb-4" data-id="element-167">
                  We Stock Ammunition For:
                </h3>
                <ul className="grid sm:grid-cols-2 gap-3" data-id="element-168">
                  {categories.map((item, index) => <li key={index} className="flex items-start" data-id="element-169">
                      <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-170" />
                      <span className="text-brand-charcoal/90" data-id="element-171">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="bg-brand-cream border-l-4 border-brand-leather p-6 mb-8" data-id="element-172">
                <p className="text-brand-charcoal/90 font-medium" data-id="element-173">
                  Inventory changes rapidly. Please call the store for current
                  availability on specific calibers and loads.
                </p>
              </div>

              <a href="tel:507-368-4696" className="inline-flex bg-brand-hunter hover:bg-brand-wood text-brand-offwhite px-8 py-4 rounded-sm font-medium transition-colors items-center" data-id="element-174">
                <Phone className="w-5 h-5 mr-2" data-id="element-175" />
                Call for Current Availability
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
}